import React, { useEffect } from 'react';
import type { MenuProps } from 'antd';
import { Breadcrumb, Button, ConfigProvider, Layout, Menu, Tag, theme } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { IPage } from '../common/models';
import { appConfig } from '../common/config';
import { useAppDispatch } from '../hook';
import { logout } from '../pages/login/_slice';
import logo from '../assets/logo.png';
import './styles.css';
import { isSystemAdmin } from '../common/helper';

const { Header, Content, Footer } = Layout;

const navMenus: MenuProps['items'] = [
  {
    key: appConfig.pages.customers.key,
    label: <Link to={appConfig.pages.customers.url}>{appConfig.pages.customers.title}</Link>,
  },
  {
    key: appConfig.pages.devices.key,
    label: <Link to={appConfig.pages.devices.url}>{appConfig.pages.devices.title}</Link>,
  },
  {
    key: appConfig.pages.events.key,
    label: <Link to={appConfig.pages.events.url}>{appConfig.pages.events.title}</Link>,
  },
  {
    key: appConfig.pages.deviceUpdates.key,
    label: <Link to={appConfig.pages.deviceUpdates.url}>{appConfig.pages.deviceUpdates.title}</Link>,
  },
]

const LayoutStandard: React.FC<{
  children: React.ReactNode,
  page: IPage,
  count?: number,
}> = ({children, page, count}) => {
  const dispatch = useAppDispatch();
  const {
    token: { borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    document.title = page.title;
  }, [page]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: '#151c26'
          },
        },
      }}
    >
      <Layout>
        <Header style={{ display: 'flex', alignItems: 'center', padding: '0 10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginRight: 16, height: 60 }}>
            <img src={logo} alt="Logo" style={{ width: 40, height: 'auto' }} />
            <div style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}></div>
          </div>
          <Menu
            theme="dark"
            mode="horizontal"
            style={{ flex: 1, minWidth: 0, backgroundColor: '#151c26', fontWeight: 'bold' }}
            items={navMenus}
            defaultSelectedKeys={['customers']}
            selectedKeys={[page.key]}
            className="nav-menu"
          />
          <div>
            { isSystemAdmin() && <Tag color="blue">System Admin</Tag> }
            <Button color="cyan" variant="link" onClick={() => {dispatch(logout())}} style={{ padding: 0 }}>
              <UserOutlined /> Log out
            </Button>
          </div>
        </Header>
        <div style={{ padding: '0 20px' }}>
          <Breadcrumb
            style={{ margin: '16px 0' }}
            items={[
              {
                title: (
                  <>
                    <HomeOutlined />
                    <span style={{ marginLeft: 4 }}>Home</span>
                  </>
                ),
                href: '/',
              },
              {
                title: page.title + (typeof count === 'number' ? ` (${count})` : ''),
              },
            ]}
          >
          </Breadcrumb>
          <Layout
            style={{ borderRadius: borderRadiusLG }}
          >
            <Content style={{ minHeight: 280 }}>{children}</Content>
          </Layout>
        </div>
        <Footer style={{ textAlign: 'center' }}>
          ©{new Date().getFullYear()} Developed by PiPIoT.
        </Footer>
      </Layout>
    </ConfigProvider>
  );
};

export default LayoutStandard;